const ja_JP = {
    info: {
        title: "あやめボタン",
        info: "通知",
        null: "空",
        subscriber: "現在までのチャンネル登録者人数:",
        author: "音声ボタンユナイテッドスタジオ × 幽世鬼神の居酒屋 2020",
        audioStaff: "感謝リストとウェブサイト情報",
        toGithub: "Githubに関する貴重なフィードバックを提供してください",
        notOfficial: "このサイトはファンの作品であり、公式とは関係ありません。アップロードした音声ファイルがあなたの権利を侵害している場合は、すぐに削除するように私たちに通知してください: support@vbup.org",
        overlapTips: "声重なる再生モードは手動で停止できません。大量のスレッドを作成するので、後リフレッシュしてください。"
    },
    action: {
        toggleNavbar: "ナビゲーションバーを切り替える",
        random: "● 今日ランダム",
        share: "Twitterで共有して結果を確認",
        placeholder: "すきな呼び方を入力下さい",
        close: "閉じる",
        live: "● 情報パネル",
        copy: "コピー",
        stopvoice: "停止",
        randomplay: "ランダム",
        overlap: "声重なる可能",
        autoplay: "自動放送",
        playing: "現在再生：",
        noplay: "",
        vtbbtn: "VTuberの音声ボタンコレクション",
        adtitle: "● コラボレーションプロジェクト",
        weekly: "非公式翻訳と二次創作団体の週刊（中国語）",
        plan: "予定の期日",
        ing: "ライブ配信中"
    },
    lang: {
        'zh-CN': "简体中文",
        'ja-JP': "日本語",
        "en-US": "English"
    }
}
export default ja_JP;